import { createFileRoute } from "@tanstack/react-router";
import Favorites from "@/pages/Favorites";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/favorites/")({
  head: () => routeHead("/favorites/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="surface-light min-h-screen"><Favorites /></div>
  );
}
